<template>
  <DataTable
    ref="DataTable"
    :data-model="'Users'"
    :items="users"
    :loading="loading"
    @reloadData="reload()"
    :display-name-plural="$t('entities.User.Plural')"
    :display-name-singular="$t('entities.User.Singular')">
    <template #cell(color)="row">
      <div :style="'min-height:15px;background-color:'+(colors.filter(x => x.id == row.item.color)[0].value)" />
    </template>
  </DataTable>
</template>
<script>
import DataTable from '@components/admin/DataTable';
import DoctorColors from '@utils/doctorColors';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      users: [],
      loading: true,
      colors: DoctorColors
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    '$i18n.locale': function () {
      this.reload();
    }
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.loading = true;
      this.axios.get('/admin/users', {
        params: {
          locale: this.$i18n.locale
        }
      }).then((res) => {
        if (res.status === 200 && res.data.result.length > 0) {
          this.users = res.data.result;
        } else {
          this.users = [];
        }
        this.loading = false;
      }).catch((err) => Promise.reject(err)).finally(() => {
        this.$refs.DataTable.finishSpinner();
      });
    }
  }
};
</script>
<style scoped></style>
